import React, { useState, useRef } from "react";
import styled from "styled-components";
import emailjs from "emailjs-com"; // ✅ Added

// Assets
import ContactImg1 from "../../assets/img/contact-1.png";
import ContactImg2 from "../../assets/img/contact-2.png";
import ContactImg3 from "../../assets/img/contact-3.png";
import BlogBox from "../Elements/BlogBox";
import ReviewModal from "../Elements/ReviewModal";
import ReviewDisplay from "../Elements/ReviewDisplay";

export default function Contact() {
  const [showModal, setShowModal] = useState(false);
  const [reviews, setReviews] = useState([]);
  const form = useRef(); // ✅ Added

  const handleAddReview = (newReview) => {
    setReviews([...reviews, newReview]);
  };

  // ✅ Function to send email via EmailJS

  const sendEmail = (e) => {
  e.preventDefault();

  const formEl = form.current;
  const name = formEl.from_name.value.trim();
  const email = formEl.from_email.value.trim();
  const subject = formEl.subject.value.trim();
  const message = formEl.message.value.trim();

  if (!name || !email || !subject || !message) {
    alert("⚠️ Please fill in all fields before sending.");
    return;
  }

  // Optional: validate email format
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(email)) {
    alert("⚠️ Please enter a valid email address.");
    return;
  }

  // ✅ Continue to send via EmailJS
  emailjs
    .sendForm("service_6ayx9t5", "template_1e0enje", form.current, "CIEMKlanxOOQCnsH-")
    .then(
      (result) => {
        alert("✅ Message sent successfully!");
        console.log(result.text);
        form.current.reset();
      },
      (error) => {
        alert("❌ Failed to send message. Please try again later.");
        console.error(error.text);
      }
    );
};

  return (
    <Wrapper id="contact">
      <div className="lightBg">
        <div className="container">
          <HeaderInfo>
            <h1 className="font40 extraBold">Let's get in touch</h1>
           

       <p className="font13">
              Ready to start your project? Let's discuss how we can bring your ideas to life 
              <br />
              with our expert software development services and innovative solutions.
            </p>
          </HeaderInfo>

          <div className="row" style={{ paddingBottom: "30px" }}>
            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
              {/* ✅ Added ref & onSubmit */}
              <Form ref={form} onSubmit={sendEmail}>
                <label className="font13">First name:</label>
                <input
                  type="text"
                  name="from_name"  // ✅ must match EmailJS template
                  className="font20 extraBold"
                  required
                />

                <label className="font13">Email:</label>
                <input
                  type="email"
                  name="from_email" // ✅ must match EmailJS template
                  className="font20 extraBold"
                  required
                />

                <label className="font13">Subject:</label>
                <input
                  type="text"
                  name="subject" // ✅ must match EmailJS template
                  className="font20 extraBold"
                  required
                />

                <label className="font13">Message:</label>
                <textarea
                  rows="4"
                  cols="50"
                  name="message" // ✅ must match EmailJS template
                  className="font20 extraBold"
                  required
                />

                <SumbitWrapper className="flex">
                  <ButtonInput
  type="button"
  onClick={sendEmail}
  className="pointer animate radius8"
  style={{ maxWidth: "220px" }}
>
  Send Message
</ButtonInput>

                  {/* <ButtonInput
                    type="submit"
                    value="Send Message"
                    className="pointer animate radius8"
                    style={{ maxWidth: "220px" }}
                  /> */}
                </SumbitWrapper>
              </Form>
            </div>

            <div
              style={{
                width: "40%",
                padding: "30px",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <div style={{ marginTop: 30 }}>
                <BlogBox
                  title="New Office!"
                  text="Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor."
                  tag="company"
                  author="Luke Skywalker, 2 days ago"
                  action={() => alert("clicked")}
                />

                 
              </div>

              <div style={{ textAlign: "center", margin: "25px 0" }}></div>
            </div>
          </div>
        </div>
      </div>
    </Wrapper>
  );
}

// // ---------------- Styled Components ----------------

const Wrapper = styled.section`
  width: 100%;
`;
const HeaderInfo = styled.div`
  padding: 70px 0 30px 0;
  @media (max-width: 860px) {
    text-align: center;
  }
`;
const Form = styled.form`
  padding: 70px 0 30px 0;
  input,
  textarea {
    width: 100%;
    background-color: transparent;
    border: 0px;
    outline: none;
    box-shadow: none;
    border-bottom: 1px solid #707070;
    height: 30px;
    margin-bottom: 30px;
  }
  textarea {
    min-height: 100px;
  }
  @media (max-width: 860px) {
    padding: 30px 0;
  }
`;
const ButtonInput = styled.button`
  border: 1px solid #7620ff;
  background-color: #7620ff;
  width: 100%;
  padding: 15px;
  outline: none;
  color: #fff;
  :hover {
    background-color: #0056b3;
    border: 1px solid #7620ff;
    color: #fff;
  }
  @media (max-width: 991px) {
    margin: 0 auto;
  }
`;

const SumbitWrapper = styled.div`
  @media (max-width: 991px) {
    width: 100%;
    margin-bottom: 50px;
  }
`;





















// import React, {useState} from "react";
// import styled from "styled-components";
// // Assets
// import ContactImg1 from "../../assets/img/contact-1.png";
// import ContactImg2 from "../../assets/img/contact-2.png";
// import ContactImg3 from "../../assets/img/contact-3.png";
// import BlogBox from "../Elements/BlogBox";
// import ReviewModal from "../Elements/ReviewModal";
// import ReviewDisplay from "../Elements/ReviewDisplay";
// export default function Contact() {
//   const [showModal, setShowModal] = useState(false);
//   const [reviews, setReviews] = useState([]);

//   const handleAddReview = (newReview) => {
//     setReviews([...reviews, newReview]);
//   };
//   return (
//     <Wrapper id="contact">
//       <div className="lightBg">
//         <div className="container">
//           <HeaderInfo>
//             <h1 className="font40 extraBold">Let's get in touch</h1>
//            <p className="font13">
//   Ready to start your project? Let's discuss how we can bring your ideas to life 
//   <br />
//   with our expert software development services and innovative solutions.
// </p>
//           </HeaderInfo>
//           <div className="row" style={{ paddingBottom: "30px" }}>
//             <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
//               <Form>
//                 <label className="font13">First name:</label>
//                 <input type="text" id="fname" name="fname" className="font20 extraBold" />
//                 <label className="font13">Email:</label>
//                 <input type="text" id="email" name="email" className="font20 extraBold" />
//                 <label className="font13">Subject:</label>
//                 <input type="text" id="subject" name="subject" className="font20 extraBold" />
//                 <textarea rows="4" cols="50" type="text" id="message" name="message" className="font20 extraBold" />
//               </Form>
//               <SumbitWrapper className="flex">
//                 <ButtonInput type="submit" value="Send Message" className="pointer animate radius8" style={{ maxWidth: "220px" }} />
//               </SumbitWrapper>
//             </div>
//            <div style={{width:'40%',padding: "30px", alignItems:'center', justifyContent:'center'}}>

//                 <div style={{marginTop:30,}}>
//                             <BlogBox
//                               title="New Office!"
//                               text="Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor."
//                               tag="company"
//                               author="Luke Skywalker, 2 days ago"
//                               action={() => alert("clicked")}
//                             />
//                           </div>


//                              <div style={{ textAlign: 'center', margin: '25px 0' }}>
                              
      
      
//       </div>
              
//             </div>
//           </div>
//         </div>
//       </div>
//     </Wrapper>
//   );
// }

// const Wrapper = styled.section`
//   width: 100%;
// `;
// const HeaderInfo = styled.div`
//   padding: 70px 0 30px 0;
//   @media (max-width: 860px) {
//     text-align: center;
//   }
// `;
// const Form = styled.form`
//   padding: 70px 0 30px 0;
//   input,
//   textarea {
//     width: 100%;
//     background-color: transparent;
//     border: 0px;
//     outline: none;
//     box-shadow: none;
//     border-bottom: 1px solid #707070;
//     height: 30px;
//     margin-bottom: 30px;
//   }
//   textarea {
//     min-height: 100px;
//   }
//   @media (max-width: 860px) {
//     padding: 30px 0;
//   }
// `;
// const ButtonInput = styled.input`
//   border: 1px solid #7620ff;
//   background-color: #7620ff;
//   width: 100%;
//   padding: 15px;
//   outline: none;
//   color: #fff;
//   :hover {
//     background-color: #580cd2;
//     border: 1px solid #7620ff;
//     color: #fff;
//   }
//   @media (max-width: 991px) {
//     margin: 0 auto;
//   }
// `;
// const ContactImgBox = styled.div`
//   max-width: 180px; 
//   align-self: flex-end; 
//   margin: 10px 30px 10px 0;
// `;
// const SumbitWrapper = styled.div`
//   @media (max-width: 991px) {
//     width: 100%;
//     margin-bottom: 50px;
//   }
// `;
// const ReviewButton = styled.button`
//   background: #7620ff;
//   color: white;
//   border: none;
//   padding: 10px 24px;
//   border-radius: 10px;
//   font-size: 14px;
//   cursor: pointer;
//   transition: all 0.3s ease;
  
//   &:hover {
//     background: #0056b3;
//     transform: translateY(-2px);
//     box-shadow: 0 4px 8px rgba(0, 123, 255, 0.3);
//    }
// `;








